import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NavMenu } from '@shopify/app-bridge-react';

import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Rewards from './pages/Rewards';
import Push from './pages/Push';
import Surveys from './pages/Surveys';
import SurveyResults from './pages/SurveyResults';
import Offers from './pages/Offers';
import Journeys from './pages/Journeys';
import ContentLibrary from './pages/ContentLibrary';
import Settings from './pages/Settings';
import AppTranslations from './pages/AppTranslations';
import CommunityModeration from './pages/CommunityModeration';
import AppCommunityModeration from './pages/AppCommunityModeration';
import Professionals from './pages/Professionals';

// Detect basename: /panel when loaded from /panel/*, empty when Shopify loads at root
const basename = window.location.pathname.startsWith('/panel') ? '/panel' : '';

export default function App() {
  return (
    <AppProvider i18n={enTranslations}>
      <BrowserRouter basename={basename}>
        <NavMenu>
          <a href="/" rel="home">Dashboard</a>
          <a href="/users">Users</a>
          <a href="/rewards">Rewards</a>
          <a href="/push">Push Notifications</a>
          <a href="/surveys">Surveys</a>
          <a href="/offers">Ofertas</a>
          <a href="/journeys">Journeys</a>
          <a href="/content">Contenido</a>
          <a href="/app-community">Comunidad de la app</a>
          <a href="/community-moderation">Comunidad (web)</a>
          <a href="/professionals">Consultorio</a>
          <a href="/app-translations">Traducciones</a>
          <a href="/settings">Configuración</a>
        </NavMenu>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:id" element={<UserDetail />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/push" element={<Push />} />
          <Route path="/surveys" element={<Surveys />} />
          <Route path="/surveys/:id/results" element={<SurveyResults />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/journeys" element={<Journeys />} />
          <Route path="/content" element={<ContentLibrary />} />
          <Route path="/community-moderation" element={<CommunityModeration />} />
          <Route path="/app-community" element={<AppCommunityModeration />} />
          <Route path="/professionals" element={<Professionals />} />
          <Route path="/app-translations" element={<AppTranslations />} />
          <Route path="/settings" element={<Settings />} />
          {/* Backwards compat redirects */}
          <Route path="/subscriptions" element={<Navigate to="/settings" replace />} />
          <Route path="/meditations" element={<Navigate to="/settings" replace />} />
          <Route path="/points-config" element={<Navigate to="/settings" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
